// extracted by mini-css-extract-plugin
export default {"articleMain":"SectionLegalArticle_articleMain__E2r0p","noSidePaddings":"SectionLegalArticle_noSidePaddings__DP0sc"};